import axios from "axios";

export const getTenant = async id => {
  const response = await axios.get(`/api/tenants/${id}`);
  return response.data;
};

export const createTenant = async tenant => {
  const response = await axios.post(`/api/tenants`, { tenant });
  return response.data;
};

export const updateTenant = async tenant => {
  const response = await axios.put(`/api/tenants`, { tenant });
  return response.data;
};

export const getTenantTree = async id => {
  const response = await axios.get(`/api/tenants-tree/${id}`);
  return response.data;
};

export const deleteTenant = async id => {
  const response = await axios.delete(`/api/tenants/${id}`);
  return response.data;
};
